<div class="d-flex flex-column align-items-center">
    <div class="dialog-header">
        <div class="icon-wrapper">
            <span
                hamIconShapes
                type="square"
                variant="purple"
                size="lg"
                icon="assets/hamIcons/add-user.svg"
                color="red"
                class="no-hover"
            ></span>
        </div>
        <span class="dialog-header__title">{{ dialogData.titleLocalizationKey | i18next }}</span>
    </div>
    <div class="dialog-body">
        <span class="dialog-body__text">
            {{ dialogData.contentMessage | i18next }}
        </span>
        <input
            class="email-input"
            hamInput
            suffixIcon="assets/hamIcons/envelope-outline.svg"
            [placeholder]="dialogData.emailInputPlaceholderKey | i18next"
            [formControl]="emailFormControl"
            (keydown.,)="$event.preventDefault(); onKeyPress()"
            (keydown.enter)="onKeyPress()"
        />
    </div>
</div>
<span
    class="email-item"
    *ngFor="let email of emailChips; let i = index"
    hamBadge
    color="primary"
    size="small"
    (cancel)="onRemoveEmail(i)"
    [hasCancelIcon]="true"
    >{{ email }}</span
>
